<template>
<svg viewBox="0 0 12 12" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Lock`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 3.5C4.5 2.67158 5.17158 2 6 2C6.82842 2 7.5 2.67158 7.5 3.5V5.5H4.5V3.5ZM2.5 5.5V3.5C2.5 1.567 4.06702 0 6 0C7.93298 0 9.5 1.567 9.5 3.5V5.5H10C10.2761 5.5 10.5 5.72386 10.5 6V10.5C10.5 10.7761 10.2761 11 10 11H2C1.72386 11 1.5 10.7761 1.5 10.5V6C1.5 5.72386 1.72386 5.5 2 5.5H2.5ZM6 6.5C6.55228 6.5 7 6.94772 7 7.5V9C7 9.55228 6.55228 10 6 10C5.44772 10 5 9.55228 5 9V7.5C5 6.94772 5.44772 6.5 6 6.5Z"/></svg>
</template>
<script>

export default {
  name: 'IconLock',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
